import { createAction } from '@ngrx/store';
import { AutomaticAdviceCsvUploadResponse, AutomaticAdviceCustomersPreferencesLastUpdateResponse } from 'src/app/shared/models';

import { createHTTPActions } from '../../shared/store/create-http-actions';
import { ControlType } from '../models/control-room-models';

export const showRecalculateBbaAdviceModal =
  createAction('Show Recalculate BBA Advice Modal');

export const [
  triggerRecalculateBbaAdvice,
  triggerRecalculateBbaAdviceSuccess,
  triggerRecalculateBbaAdviceError,
] = createHTTPActions<undefined, undefined, undefined>('Trigger Recalculate BBA Advice');

export const [
  getAutomaticFlowSchedulerEnabledState,
  getAutomaticFlowSchedulerEnabledStateSuccess,
  getAutomaticFlowSchedulerEnabledStateError,
] = createHTTPActions<
  { type: ControlType },
  { type: ControlType; enabled: boolean },
  undefined
>('Get Automatic Flow Scheduler Enabled State');

export const [triggerAutomaticFlow, triggerAutomaticFlowSuccess, triggerAutomaticFlowError] =
  createHTTPActions<
    { type: ControlType },
    { type: ControlType },
    { type: ControlType }
  >('Trigger Automatic Flow');

export const [
  setAutomaticFlowEnabledState,
  setAutomaticFlowEnabledStateSuccess,
  setAutomaticFlowEnabledStateError,
] = createHTTPActions<
  { type: ControlType; enabled: boolean },
  { type: ControlType; enabled: boolean },
  undefined
>('Set Automatic Flow Enabled State');

export const [
  uploadCompanySettingsFromCsv,
  uploadCompanySettingsFromCsvSuccess,
  uploadCompanySettingsFromCsvError,
] = createHTTPActions<{ file: File }, { response: AutomaticAdviceCsvUploadResponse }, undefined>(
  'Upload Company Settings From Csv',
);

export const [
  setAutomaticAdviceCustomersPreferences,
  setAutomaticAdviceCustomersPreferencesSuccess,
  setAutomaticAdviceCustomersPreferencesError,
] = createHTTPActions<undefined, undefined, { isNotFound?: boolean }>('Set Automatic Advice Customers Preferences');

export const [
  getAutomaticAdviceCustomersPreferencesLastUpdate,
  getAutomaticAdviceCustomersPreferencesLastUpdateSuccess,
  getAutomaticAdviceCustomersPreferencesLastUpdateError,
] = createHTTPActions<undefined, AutomaticAdviceCustomersPreferencesLastUpdateResponse, undefined>(
  'Get Automatic Advice Customers Preferences Last Update');

export const [
  resetAutomaticAdviceForAllCustomers,
  resetAutomaticAdviceForAllCustomersSuccess,
  resetAutomaticAdviceForAllCustomersError,
] = createHTTPActions<undefined, undefined, undefined>(
  'Reset Automatic Advice For All Customers',
);
